import Marquee from "react-fast-marquee";
import { SiSpotify, SiApplemusic, SiYoutubemusic, SiYoutube, SiDeezer, SiTidal, SiTiktok, SiFacebook, SiInstagram, SiPandora, SiSoundcloud, SiIheartradio, SiNapster, SiShazam, SiAudiomack, SiBeatport, SiKuaishou, SiMeta, SiMixcloud, SiPeloton, SiAlibabadotcom, SiRumble, SiTwitch, SiSnapchat, SiPinterest, SiBandcamp, SiRoblox, SiWechat, SiAlipay, SiThreads, SiVk } from "react-icons/si";
import { Music2 } from "lucide-react";
import { PLATFORMS } from "@/lib/data";
import { FadeUp } from "./AnimatedSection";
import { useLanguage } from "@/context/LanguageContext";

const stripAccents = (str) => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

const ICON_MAP = {
  spotify: SiSpotify,
  applemusic: SiApplemusic,
  youtubemusic: SiYoutubemusic,
  youtube: SiYoutube,
  deezer: SiDeezer,
  tidal: SiTidal,
  tiktok: SiTiktok,
  facebook: SiFacebook,
  instagram: SiInstagram,
  pandora: SiPandora,
  soundcloud: SiSoundcloud,
  iheartradio: SiIheartradio,
  napster: SiNapster,
  shazam: SiShazam,
  audiomack: SiAudiomack,
  beatport: SiBeatport,
  kuaishou: SiKuaishou,
  meta: SiMeta,
  mixcloud: SiMixcloud,
  peloton: SiPeloton,
  alibaba: SiAlibabadotcom,
  rumble: SiRumble,
  twitch: SiTwitch,
  snapchat: SiSnapchat,
  pinterest: SiPinterest,
  bandcamp: SiBandcamp,
  roblox: SiRoblox,
  wechat: SiWechat,
  alipay: SiAlipay,
  threads: SiThreads,
  vk: SiVk,
  generic: Music2,
};

const BRAND_COLORS = {
  spotify: "#1ED760",
  applemusic: "#FA243C",
  youtubemusic: "#FF0000",
  youtube: "#FF0000",
  deezer: "#FEAA2D",
  tidal: "#00FFFF",
  tiktok: "#25F4EE",
  facebook: "#1877F2",
  instagram: "#E4405F",
  pandora: "#00A9E0",
  soundcloud: "#FF5500",
  iheartradio: "#C6002B",
  napster: "#FF0000",
  shazam: "#0088FF",
  audiomack: "#FFA200",
  beatport: "#01FF95",
  kuaishou: "#FF5000",
  meta: "#0866FF",
  mixcloud: "#5000FF",
  peloton: "#FFFFFF",
  alibaba: "#FF6A00",
  rumble: "#85C742",
  twitch: "#9146FF",
  snapchat: "#FFFC00",
  pinterest: "#BD081C",
  bandcamp: "#408294",
  roblox: "#FFFFFF",
  wechat: "#07C160",
  alipay: "#1677FF",
  threads: "#FFFFFF",
  vk: "#0077FF",
  yandex: "#FF0000",
  canva: "#00C4CC",
};

export const PlatformsMarquee = () => {
  const { t } = useLanguage();

  return (
    <section id="plataformas" data-testid="platforms-section" className="relative py-20 border-y border-white/[0.06] bg-[#0C0C0C] overflow-hidden">
      <FadeUp className="max-w-7xl mx-auto px-6 lg:px-8 mb-10 flex items-center justify-between flex-wrap gap-4">
        <p className="text-brand-red text-xs font-mono tracking-[0.25em] font-semibold uppercase">{t.marquee.label}</p>
        <h2 className="font-heading text-xl md:text-2xl font-bold text-white max-w-xl">{t.marquee.title}</h2>
      </FadeUp>

      <Marquee speed={32} gradient={false} pauseOnHover className="marquee-fade-mask [&>div]:items-center">
        {PLATFORMS.map((p, i) => {
          const Icon = ICON_MAP[p.icon] || Music2;
          const brandColor = BRAND_COLORS[p.icon] || (i % 2 === 0 ? "#FF2436" : "#2E5EFF");
          return (
            <div
              key={p.name}
              data-testid={`platform-chip-${stripAccents(p.name).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              style={{ "--brand-color": brandColor }}
              className="group mx-4 px-6 py-3 rounded-full border border-white/10 bg-white/[0.03] whitespace-nowrap flex items-center gap-2.5 transition-colors duration-300 hover:border-[color:var(--brand-color)]/50"
            >
              <Icon className="w-4 h-4 text-neutral-400 transition-colors duration-300 group-hover:text-[color:var(--brand-color)]" />
              <span className="font-heading text-sm md:text-base font-medium text-neutral-300 tracking-wide">{p.name}</span>
            </div>
          );
        })}
        <div data-testid="platform-chip-more" className="mx-4 px-6 py-3 rounded-full border border-white/15 bg-white/[0.05] whitespace-nowrap">
          <span className="font-heading text-sm md:text-base font-semibold text-white tracking-wide">{t.marquee.more}</span>
        </div>
      </Marquee>

      <p className="max-w-7xl mx-auto px-6 lg:px-8 mt-10 text-[11px] text-neutral-600 leading-relaxed">
        {t.marquee.disclaimer}
      </p>
    </section>
  );
};
